import { Routes } from '@angular/router';
import { authGuard } from './services/auth/auth.guard';

export const checkoutLayoutRoutes: Routes = [
  {
    path: 'checkout',
    loadComponent: () => import('./layouts/checkout/checkout-layout.component').then((m) => m.CheckoutLayoutComponent),
    children: [
      {
        path: ':offerid',
        loadComponent: () => import('./pages/checkout/checkout.page').then((m) => m.CheckoutPage),
        canActivate: [authGuard],
      },
    ],
  },
  {
    path: 'bookings/:id',
    loadComponent: () => import('./layouts/checkout/checkout-layout.component').then((m) => m.CheckoutLayoutComponent),
    children: [
      {
        path: 'pay',
        loadComponent: () => import('./pages/booking-payment/booking-payment.page').then((m) => m.BookingPaymentPage),
        canActivate: [authGuard],
      },
      {
        path: 'processing',
        loadComponent: () =>
          import('./pages/booking-processing/booking-processing.page').then((m) => m.BookingProcessingPage),
        canActivate: [authGuard],
      },
      {
        path: 'confirmed',
        loadComponent: () =>
          import('./pages/booking-confirmation/booking-confirmation.page').then((m) => m.BookingConfirmationPage),
        canActivate: [authGuard],
      },
      {
        path: 'failed',
        loadComponent: () => import('./pages/booking-error/booking-error.page').then((m) => m.BookingErrorPage),
        canActivate: [authGuard],
      },
    ],
  },
  {
    path: 'vehicle-inspection/:step',
    loadComponent: () =>
      import('./vehicle-inspection/pages/vehicle-inspection/vehicle-inspection.page').then(
        (m) => m.VehicleInspectionPage
      ),
  },
  {
    path: 'vehicle-inspection',
    loadComponent: () =>
      import('./vehicle-inspection/pages/vehicle-inspection/vehicle-inspection.page').then(
        (m) => m.VehicleInspectionPage
      ),
  },
];
